import { Component, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TruckJourneyListComponent } from '../../components/list/truck-journey-list.component';
import { Carrier } from '../../../../user-dashboard/shared/carrier.model';
import { Region } from '../../../../user-dashboard/shared/region.model';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ErrorHandlerService } from '../../../../shared/services/error-handler.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-truck-journey-search',
  templateUrl: './truck-journey-search.component.html',
})
export class TruckJourneySearchComponent {

  @ViewChild('truckJourneyList') private truckJourneyListComponent: TruckJourneyListComponent;

  public carriers: Carrier[] = [];
  public regions: Region[] = [];
  public selectedCarrier: Carrier = null;
  public selectedRegion: Region = null;
  public isGlobalUser: boolean = this.authService.canManageGlobalTruckJourneys();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private errorHandler: ErrorHandlerService
  ) {}

  public updateSelectedRegion(newRegion: Region): void {
    this.selectedRegion = newRegion;
    if (newRegion == null) {
      this.updateSelectedCarrier(null);
    } else {
      this.addQueryParam({ regionId: newRegion?.id });
    }
  }

  public updateSelectedCarrier(newCarrier: Carrier): void {
    this.selectedCarrier = newCarrier;
    this.addQueryParam({
      regionId: this.selectedRegion?.id,
      carrierId: newCarrier?.id
    });
  }

  public handleHeaderRegionFetchErrors(error: HttpErrorResponse): void {
    return this.errorHandler.handleHttpError(error, 'truck-journeys.errors.fetch-regions');
  }

  public handleHeaderCarrierFetchErrors(error: HttpErrorResponse): void {
    return this.errorHandler.handleHttpError(error, 'truck-journeys.errors.fetch-carriers');
  }

  private addQueryParam(queryParam: any): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParam,
      queryParamsHandling: 'merge',
    });
  }
}
